import { PaletteMode } from '@mui/material'
import { createSlice } from '@reduxjs/toolkit'

import type { RootState } from './store'

interface GuiState {
    version: string
    themeMode: PaletteMode
    user_email: string
}

const prefersDarkMode: boolean = window.matchMedia('(prefers.color-scheme: dark)').matches
const themeMode: PaletteMode = prefersDarkMode ? 'dark' : 'light'

const initialState: GuiState = {
    version: '0.0.3',
    themeMode,
    user_email: 'error',
}

const guiSlice = createSlice({
    name: 'gui',
    initialState,
    reducers: {
        toggleThemeMode: (state) => {
            state.themeMode = state.themeMode === 'light' ? 'dark' : 'light'
        },
        setUserEmail: (state, action) => {
            state.user_email = action.payload
        }
    }
})

const selectGuiState = (state: RootState): GuiState => state.gui

export const { toggleThemeMode, setUserEmail} = guiSlice.actions
export { guiSlice, initialState , selectGuiState}